import React, { Component } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { NitroIcon, NitroModal, NitroParagraph } from 'nitro-components';
import RestrictionSummary from './RestrictionSummary';

const DeleteButton = styled.button`
  border: 0;
  outline: 0;
  background: none;
`;

const CompanyCodesContainer = styled.div`
  border-bottom: 1px solid #d8d8d8;
  padding: 15px 5px 5px 10px;
  min-height: 70px;
  display: flex;
  flex-direction: column;
  justify-content: center;

  &:last-child {
    border: 0px;
  }

  .code {
    font-size: 1.1em;
    font-family: noto-sans-bold;
    //color: #00457c;
    text-transform: uppercase;
    display: flex;
    justify-content: space-between;
    cursor: pointer;
  }

  .isEmployer {
    color: #8b7c45;
  }

  .restrictions_summary {
    display: flex;
    div {
      margin: 2px 4px 4px 0px;
    }
  }

  .restrictions_edit {
    display: flex;
    .json {
      margin-bottom: 20px;
    }
    div {
      flex: 1;
      padding-right: 10px;
    }
  }
`;

const ModalContent = styled.div`
  width: 100%;
`;

class ContainerCompanyCodes extends Component {
  static propTypes = {
    allocatedRestrictions: PropTypes.arrayOf(PropTypes.object).isRequired,
    countryCode: PropTypes.string.isRequired,
    businessEntityId: PropTypes.number.isRequired,
    userid: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      AllocatedRestrictions: [],
      showModal: false,
    };

    this.removeCostCentre = this.removeCostCentre.bind(this);
    this.deleteCostCentre = this.deleteCostCentre.bind(this);
  }

  componentWillMount() {
    this.deleteAwaited = [];
  }

  componentWillReceiveProps(newProps) {
    const { allocatedRestrictions } = newProps;
    if (allocatedRestrictions) {
      this.setState({
        AllocatedRestrictions: allocatedRestrictions || [],
      });
    }
  }

  removeCostCentre = event => {
    // this.setState({ showModal: true });
    this.deleteAwaited = {
      companyCode: event.currentTarget.attributes['data-key'].value,
      countryCode: event.currentTarget.attributes['data-Id'].value,
    };
    this.props.onRemoveCostCentre(
      this.deleteAwaited,
      this.state.AllocatedRestrictions
    );
  };

  deleteCostCentre = event => {
    this.props.onRemoveCostCentre(
      this.deleteAwaited,
      this.state.AllocatedRestrictions
    );
    this.deleteReject(event);
  };

  deleteReject = event => {
    this.setState({ showModal: false });
  };
  render() {
    const divCompanyCodes = this.state.AllocatedRestrictions.map(
      (company, idx) => {
        if (company.countryCode === this.props.countryCode) {
          //check which restriction is there
          return (
            <CompanyCodesContainer
              className="companyCode"
              key={`company_code_container${idx}`}
            >
              <div className="code">
                <div>
                  {company.companyName} ({company.companyCode})
                  <DeleteButton
                    data-key={company.companyCode}
                    data-id={company.countryCode}
                    onClick={this.removeCostCentre}
                    isDisabled={false}
                  >
                    <NitroIcon name="delete" variant="base3" size={14} />
                  </DeleteButton>
                </div>
              </div>
              <div>
                <RestrictionSummary
                  companyCode={company.companyCode}
                  countryCode={company.countryCode}
                  businessEntityId={this.props.businessEntityId}
                  typeId={1}
                  Restrictions={company.restrictions}
                  onChangeRestriction={this.props.onChangeRestriction}
                  userid={this.props.userid}
                />
              </div>
            </CompanyCodesContainer>
          );
        }
      },
      this
    );

    return (
      <div>
        {divCompanyCodes}
        <NitroModal
          title="Confirm delete Cost Centre"
          action={this.deleteCostCentre}
          actionLabel="Continue"
          cancelAction={this.deleteReject}
          cancelLabel="Cancel"
          isOpen={this.state.showModal}
          close={this.deleteReject}
          messageFlexDirection="row"
        >
          <ModalContent>
            <NitroParagraph align="center" opacity="0.5">
              Do you want to delete cost centre -{' '}
              {this.deleteAwaited.companyCode} -(
              {this.deleteAwaited.countryCode}) ?
            </NitroParagraph>

            <NitroParagraph align="center" />
          </ModalContent>
        </NitroModal>
      </div>
    );
  }
}

export default ContainerCompanyCodes;



// WEBPACK FOOTER //
// ./src/features/admin/components/restrictions/CompanyCodesContainer.js